module.exports = __webpack_public_path__ + "img/c5.55a1e635.png";